<template>
    <div class="table-container">
        <div class="p-0 pt-2 pb-1 header-panel-container">
            <mdb-navbar class="z-depth-1 p-0 pl-2 rounded-sm justify-content-between">
                <mdb-navbar-brand class="table-header-navbar-brand">
                    <mdb-tabs class="table-header-tabs" :active="0" default :links="[{ text: 'Manifests' }]" />
                </mdb-navbar-brand>
                <mdb-form-inline class="ml-auto" tag="div">
                    <input
                        class="form-control mr-sm-2 table-searchterm-input border border-light"
                        :value="searchTerm"
                        @input="$emit('update:searchTerm', $event.target.value)"
                        type="text"
                        maxlength="100"
                        placeholder="Manifest / Item / Container / UPC / Batch"
                        aria-label="Search manifest number, item code, container, UPC barcode, or batch number"
                        style="margin-top: 8px!important;"
                        @keydown.enter.prevent="$emit('search')"
                    />
                    <mdb-btn type="button" color="elegant" size="sm" :disabled="loading" @click="$emit('search')"><i class="el-icon-search"></i> Search</mdb-btn>
                    <mdb-btn type="button" color="elegant" class="ml-0" size="sm" :disabled="loading" @click="$emit('clear')"><i class="el-icon-close"></i> Clear</mdb-btn>
                    <mdb-btn type="button" color="elegant" class="ml-0" size="sm" :disabled="loading" @click="$emit('refresh')"><i class="el-icon-refresh"></i> Refresh</mdb-btn>
                    <mdb-btn type="button" color="elegant" class="ml-0" size="sm" @click="$emit('filter')"><i class="el-icon-s-operation"></i> Filter</mdb-btn>
                </mdb-form-inline>
            </mdb-navbar>
        </div>
        <div class="connection-container px-2 pb-1">
            <slot name="connection"></slot>
        </div>
        <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon class="mb-2" />
        <el-table
            v-loading="loading"
            class="custom-element-table"
            :data="rows"
            row-key="ManifestId"
            border
            stripe
            size="small"
            :height="height"
            :empty-text="error ? 'Unable to load manifests' : 'No manifests found'"
        >
            <el-table-column prop="ManifestId" label="ID" width="120" />
            <el-table-column prop="ManifestNumber" label="MANIFEST NO." min-width="220">
                <template slot-scope="scope">
                    <el-button type="text" @click="$emit('row-click', scope.row)">{{ scope.row.ManifestNumber || 'View manifest' }}</el-button>
                    <Copy v-if="scope.row.ManifestNumber" :text="scope.row.ManifestNumber" />
                </template>
            </el-table-column>
            <el-table-column prop="ShipName" label="SHIP NAME" min-width="260">
                <template slot-scope="scope">{{ scope.row.ShipName || '-' }}</template>
            </el-table-column>
            <el-table-column prop="ShipDate" label="SHIP DATE" min-width="180">
                <template slot-scope="scope">{{ formatManifestDate(scope.row.ShipDate) || '-' }}</template>
            </el-table-column>
            <el-table-column prop="ETAWarehouse" label="ETA" min-width="180">
                <template slot-scope="scope">{{ formatManifestDate(scope.row.ETAWarehouse) || '-' }}</template>
            </el-table-column>
        </el-table>
        <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-size="length"
            :page-sizes="[25, 50, 100]"
            :total="total"
            :disabled="loading"
            @current-change="$emit('page-change', $event)"
            @size-change="$emit('size-change', $event)"
        />
    </div>
</template>

<script>
import { mdbBtn, mdbFormInline, mdbNavbar, mdbNavbarBrand, mdbTabs } from 'mdbvue';
import { Copy } from '../../components/thats/Thats';
import { formatManifestDate } from './formatters';

export default {
    name: 'ManifestTable',
    components: { mdbBtn, mdbFormInline, mdbNavbar, mdbNavbarBrand, mdbTabs, Copy },
    props: {
        rows: { type: Array, default: () => [] },
        searchTerm: { type: String, default: '' },
        filterSummary: { type: String, default: '' },
        page: { type: Number, default: 1 },
        length: { type: Number, default: 25 },
        total: { type: Number, default: 0 },
        height: { type: String, default: 'calc(100vh - 140px)' },
        loading: { type: Boolean, default: false },
        error: { type: String, default: '' }
    },
    methods: {
        formatManifestDate
    }
};
</script>

<style scoped>
.table-container{ padding : 0 5px } .custom-element-table{ position: relative; }
</style>
